<template>
    <div class="table">
        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;">
                    <div style="width:150px;">
                        <el-radio-group v-model="form.atdType" @change="atdTypeChange()">
                            <el-radio-button label="1">行政班</el-radio-button>
                            <el-radio-button label="2">导师班</el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;">
                    <div style="width:160px;">
                        <el-input v-model="form.atdClassName" placeholder="行政班"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;" v-if="form.atdType == 2">
                    <div style="width:160px;">
                        <el-input v-model="form.atdMentorName" placeholder="导师班"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;">
                    <div style="width:140px;">
                        <el-input v-model="form.name" placeholder="学生姓名"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;">
                    <el-date-picker
                        style="width:140px;"
                        v-model="form.startDate"
                        type="date"
                        placeholder="开始日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;">
                    <el-date-picker
                        style="width:140px;"
                        v-model="form.endDate"
                        type="date"
                        placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                    <el-button type="primary" icon="search" @click="exportExcel">导出Excel</el-button>
                </div>
                <div style="display: inline-block; height:40px;float:right;">
                    <el-button type="success" @click="queryDate(5)" v-if="form.dateType == 5">最近30天</el-button>
                    <el-button type="success" plain @click="queryDate(5)" v-if="form.dateType != 5">最近30天</el-button>
                    <el-button type="success" plain @click="queryDate(4)">最近7天</el-button>
                    <el-button type="success" plain @click="queryDate(3)">昨天</el-button>
                    <el-button type="success"  @click="queryDate(2)">今天</el-button>
                    <el-button type="success" plain @click="queryDate(6)">本周</el-button>
                    <el-button type="success" plain @click="queryDate(1)">本月</el-button>
                    <el-button type="success" plain @click="queryDate(0)">上月</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="450"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="学生姓名"></el-table-column>
                <el-table-column prop="classNo" label="座位号"></el-table-column>
                <el-table-column prop="atdClassName" label="行政班"></el-table-column>
                <el-table-column prop="atdMentorName" label="导师班"v-if="form.atdType == 2"></el-table-column>
                <el-table-column prop="attCount" label="出勤次数" width="100"></el-table-column>
                <el-table-column prop="absCount" label="缺勤次数" width="100"></el-table-column>
                <el-table-column prop="lateCount" label="迟到次数" width="100"></el-table-column>
                <el-table-column prop="lvCount" label="请假次数" width="100"></el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http';

    export default {
        name:"Student",
        data(){
            return{
                loading:false,
                loadingText:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    deptId:"",
                    atdType:1,
                    atdClassName:"",
                    atdMentorName:"",
                    name:"",
                    dateType:2,
                    startDate:"",
                    endDate:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[]
            }
        },
        created:function () {
            this.getDeptData();
        },
        components: {
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.queryDate(2);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中...";
                let url  = this.listCountStudentUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    atdType:this.form.atdType,
                    atdClassName:this.form.atdClassName,
                    atdMentorName:this.form.atdMentorName,
                    name:this.form.name,
                    startDate:this.form.startDate==null?"":this.form.startDate,
                    endDate:this.form.endDate==null?"":this.form.endDate
                };       
                // console.log(JSON.stringify(data))
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
           },
           queryDate(dateType){
                this.form.dateType = dateType;
                let url  = this.honorSetQueryDateUrl;
                let data = {
                    dateType:this.form.dateType
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.form.startDate=res.data.startDate;
                       this.form.endDate=res.data.endDate;
                       this.common.page = 1;
                       this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
           },
           atdTypeChange(){
                this.form.atdClassName = "";
                this.form.atdMentorName = "";
                this.common.page = 1;
                this.getData();
           },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            exportExcel(){
                const maxCount = 65535
                if(this.common.total > maxCount){
                    let msg="导出数据超出"+maxCount+"条平台不支持，请缩小数据范围查询，然后再进行导出操作！"
                    this.$commonFn.showTip(msg,3)
                }else{
                    this.exportData()
                }
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";
                let url=this.excelCountDownloadStudentUrl;
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('atdType', this.form.atdType);
                param.append('atdClassName', this.form.atdClassName);
                param.append('name', this.form.name);
                param.append('startDate', this.form.startDate==null?"":this.form.startDate);
                param.append('endDate', this.form.endDate==null?"":this.form.endDate);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '学生考勤.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error); 
                    this.loading=false;
                });
           },

        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/count/student/StudentAttendance.vue